import "./BlogLayout.css";

function BlogLayout({ sidebar, content, right }) {
  return (
    <div className="blog-layout">
      <aside className="blog-sidebar">{sidebar}</aside>
      <main className="blog-content">{content}</main>
      <div className="blog-right">{right}</div>
    </div>
  );
}

export default BlogLayout;